import { Dialog, DialogProps } from '@material-ui/core'

import Card from '@/components/card'

import { Form } from './form'
import { useStyles } from './styles'

interface AddFolderModalProps extends DialogProps {
  onClose: () => void
}

export const AddFolderModal = ({ onClose, ...args }: AddFolderModalProps) => {
  const classes = useStyles()

  return (
    <Dialog onClose={onClose} {...args}>
      <Card className={classes.card} contentClassName={classes.cardContent}>
        <Form handleClose={onClose} />
      </Card>
    </Dialog>
  )
}
